import React from 'react';
import { ToastContainer } from 'react-toastify';
import NocNavBar from '../../../../../layouts/noc/NocNavBar';
import FiberPptpBody from './FiberPptpBody';
import useCheckTwoDepartments from '../../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import { admin, NOC } from '../../../../../../utils/config';
import { useUser } from '../../../../../../hooks/shared/user/useUser';
import FiberPptpProvider from './context/FiberPptpProvider';
import { VICE_PRESIDENT_FSE } from '../../../../../../utils/departments/helpers';

const FiberPptp = ({ history }) => {
  const { profile } = useUser();
  const { firstName } = profile;
  useCheckTwoDepartments(`${NOC}`, `${VICE_PRESIDENT_FSE}`, `${admin}`, history);
  return (
    <div className="s-layout">
      <FiberPptpProvider>
        <main className="s-layout__content col-lg-10 p-0">
          <NocNavBar currentPage="NOC Sheet - Fiber PTP" position={firstName} />
          <div className="container">
            <div className="row mt-5">
              <div className="mt-4 col-lg-12 col-md-12 col-sm-12">
                <FiberPptpBody />
              </div>
            </div>
          </div>
        </main>
        <ToastContainer />
      </FiberPptpProvider>
    </div>
  );
};

export default FiberPptp;
